import { API_BASE, request } from "./base";

// --- Bucket Browser ---

export interface BucketItem {
  name: string;
  path: string;
  type: "directory" | "file";
  size?: number;
  updated?: string | null;
  contentType?: string | null;
}

export interface BucketBrowseResponse {
  bucket: string;
  prefix: string;
  directories: BucketItem[];
  files: BucketItem[];
}

export interface BucketFileContent {
  path: string;
  size: number;
  contentType: string | null;
  updated?: string | null;
  truncated: boolean;
  content: string;
}

export async function browseBucket(
  tenantId: string,
  prefix = ""
): Promise<BucketBrowseResponse> {
  const qs = new URLSearchParams();
  if (prefix) qs.set("prefix", prefix);
  return request<BucketBrowseResponse>(
    `/api/tenants/${tenantId}/bucket/browse?${qs.toString()}`
  );
}

export async function readBucketFile(
  tenantId: string,
  path: string
): Promise<BucketFileContent> {
  const qs = new URLSearchParams({ path });
  return request<BucketFileContent>(
    `/api/tenants/${tenantId}/bucket/read?${qs.toString()}`
  );
}

export async function saveBucketFile(
  tenantId: string,
  path: string,
  content: string
): Promise<{ path: string; size: number; contentType: string; updated: string }> {
  const qs = new URLSearchParams({ path });
  return request(
    `/api/tenants/${tenantId}/bucket/write?${qs.toString()}`,
    {
      method: "PUT",
      body: JSON.stringify({ content }),
    }
  );
}

export function getBucketDownloadUrl(tenantId: string, path: string): string {
  const qs = new URLSearchParams({ path });
  // API_BASE는 이미 /api/agent-proxy 이므로 /api prefix 없이 이어붙인다.
  return `${API_BASE}/tenants/${tenantId}/bucket/download?${qs.toString()}`;
}
